import { render, staticRenderFns } from "./SidebarMenuPrincipal.vue?vue&type=template&id=0a901a70"
import script from "./SidebarMenuPrincipal.vue?vue&type=script&lang=js"
export * from "./SidebarMenuPrincipal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports